
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"30","viewBox":"0 0 40 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.25 0H3.75003C1.68213 0 0 1.68213 0 3.75003V26.25C0 28.3179 1.68213 30 3.75003 30H36.25C38.3179 30 40 28.3179 40 26.25V3.75003C40 1.68213 38.3179 0 36.25 0ZM36.25 2.49999C36.4198 2.49999 36.5814 2.53523 36.7291 2.59676L20 17.096L3.27084 2.59676C3.41854 2.53531 3.58011 2.49999 3.74994 2.49999H36.25ZM36.25 27.5H3.75003C3.06034 27.5 2.49999 26.9397 2.49999 26.2499V5.23803L19.1809 19.6948C19.4165 19.8986 19.7083 20 20 20C20.2917 20 20.5835 19.8987 20.8191 19.6948L37.5 5.23803V26.25C37.4999 26.9397 36.9397 27.5 36.25 27.5Z"}})])
          )
        }
      }
    